import { Component, effect, OnInit, inject } from '@angular/core';
import { FilterBuilder } from '../../../helper/filter.builder';
import { FolderDataShareObject } from '@libs/types/src/services/object-type/folder/folder-data-share.object';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { PersonShareDataWithServiceStore } from './person-share-data-with-service.store';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { dateField } from '../../../../shared/components/kit/table/table.fields';
import { PersonShareDataDialogComponent } from './person-share-data-dialog/person-share-data-dialog.component';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';

@Component({
    selector: 'app-person-share-data-with-service',
    templateUrl: './person-share-data-with-service.component.html',
    providers: [PersonShareDataWithServiceStore],
    imports: [
        TableComponent,
    ],
})
export class PersonShareDataWithServiceComponent implements OnInit {
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly store = inject(PersonShareDataWithServiceStore);
    private readonly confirm = inject(ConfirmBuilder);
    private readonly translate = inject(TranslateService);

    protected columns = [
        { name: 'service', data: (service: any) => service.name },
        dateField('dateFrom', false, false),
        dateField('dateTo', false, false),
        { name: 'note', type: TableColumnType.String50 },
    ];

    constructor() {
        const store = this.store;
        store.doOnActions(
            () => this.getShares(),
            'updateFolderDataShare', 'createFolderDataShare', 'deleteFolderDataShare',
        );

        effect(() => {
            this.store.folderId();
            this.getShares();
        });
    }

    public async ngOnInit() {
        await this.getShares();
    }

    openDialog(share?: FolderDataShareObject | null) {
        this.dialogService.open(PersonShareDataDialogComponent, {
            data: { share },
            header: this.translate.instant(share ? 'person.dashboard.dataShare.edit' : 'person.dashboard.dataShare.create'),
        });
    }

    protected detail(item: FolderDataShareObject) {
        this.openDialog(item);
    }

    protected delete(event: any) {
        this.confirm.confirmDelete(
            () => this.store.api.deleteFolderDataShare({ id: event.item.id }),
            event,
        );
    }

    private async getShares(): Promise<void> {
        const folderId = this.store.folderId();
        if (!folderId) return;
        const filter = new FilterBuilder()
            .folderId(folderId)
            .limit(10)
            .sort('dateFrom');
        await this.store.api.getFolderDataShares(filter.create());
    }
}
